import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import {
  AdapterOptions,
  FlatAnswerMutation,
  SectionAdapter
} from 'components/Assessments/adapters/types'
import { PatFormData } from 'components/Assessments/PatAssessment/types/PatFormData'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { PatientVerificationAdapter } from './subsections/patient-verification/adapter'
import { HistoryAndDiagnosesAdapter } from './subsections/history-and-diagnoses/adapter'

/**
 * Array of all patient background subsection adapter instances
 */
const PATIENT_BACKGROUND_SUBSECTION_ADAPTERS: SectionAdapter<PatFormData>[] = [
  new PatientVerificationAdapter(),
  new HistoryAndDiagnosesAdapter()
]

/**
 * Patient Background section adapter
 * Aggregates all patient background subsections
 */
export class PatientBackgroundAdapter extends SectionAdapter<PatFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options?: AdapterOptions
  ): Partial<PatFormData> {
    const formData: Partial<PatFormData> = {}

    // Extract data from all subsection adapters
    for (const adapter of PATIENT_BACKGROUND_SUBSECTION_ADAPTERS) {
      const subsectionData = adapter.extractFormData(flatAnswers, options)
      Object.assign(formData, subsectionData)
    }

    return formData
  }

  buildFlatAnswers(formData: PatFormData): FlatAnswerMutation[] {
    const allMutations: FlatAnswerMutation[] = []

    // Build mutations from all subsection adapters
    for (const adapter of PATIENT_BACKGROUND_SUBSECTION_ADAPTERS) {
      if (adapter instanceof BaseSubsectionAdapter) {
        adapter.setFormData(formData)
        allMutations.push(...adapter.buildFlatAnswers())
      } else {
        allMutations.push(...adapter.buildFlatAnswers(formData))
      }
    }

    return allMutations
  }
}
